import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ConsentState, RootState } from 'types/state'

const initialState: ConsentState = {
  analytics: null,
  bannerEnabled: false,
}

export const consentSlice = createSlice({
  name: 'consent',
  initialState,
  reducers: {
    setAnalyticsConsent: (state: ConsentState, { payload }: PayloadAction<boolean>) => {
      state.analytics = payload
    },
    setCookieBannerEnabled: (state: ConsentState, { payload }: PayloadAction<boolean>) => {
      state.bannerEnabled = payload
    },
  },
})

export const consentActions = consentSlice.actions
export default consentSlice.reducer

export const consentSelectors = {
  analytics: (state: RootState) => state.consentState.analytics,
  bannerEnabled: (state: RootState) => state.consentState.bannerEnabled,
  decided: (state: RootState) => state.consentState.analytics !== null,
  analyticsAllowed: (state: RootState) =>
    state.consentState.analytics === true ||
    (state.consentState.analytics === null && !state.consentState.bannerEnabled),
}
